import { FC } from 'react';
import * as semrush from '@anm/helpers/semrush'
import ChannelInputWithButton from '@anm/components/user/YoutubeWhitelist/ChannelInputWithButton';
import { ClaimContent, ContainerWrapper, MainTitle, SecondaryTitle } from '@anm/components/user/YoutubeWhitelist';

import ChannelsListWrapper from './ChannelsListWrapper';
import CopyrightClaimWrapper from './CopyrightClaimWrapper';
import Notifications from './Notifications';
import { useAddChannelIsButtonDisable, useYoutubeListHandlers } from './hooks';

export { ContainerWrapper };

type YoutubeWhitelistProps = {
  title?: string | null;
};

const YoutubeWhitelist: FC<YoutubeWhitelistProps> = ({ title = 'YouTube Whitelist' }) => {
  const [inputText, handleInputChange, handleAddChannel] = useYoutubeListHandlers();
  const [isButtonDisabled, canShowTooltip, renderTooltip] = useAddChannelIsButtonDisable(inputText);

  const isSemrush = location.search.includes('isSemrush=true') || semrush.isSemrushIframe();
  const helpText = isSemrush
    ? ''
    : "Need help finding your YouTube channel ID? <a target='_blank' href='https://support.google.com/youtube/answer/3250431?hl=en'>Click here.<a>";

  return (
    <>
      <Notifications />
      <ContainerWrapper size={860}>
        <MainTitle
          title={title ? title : ''}
          description={
            'The audio content of our providers is 100% royalty-free and can be used safely in YouTube videos. It is still possible ' +
            'to be mistakenly flagged as wrongful use of copyrighted content. If you faced this problem, here are the proved ways to solve it:'
          }
        />
        <SecondaryTitle
          level={2}
          title="Whitelist Your YouTube Channel"
          description={`Add your YouTube Channel ID so that we'd be able to remove the claims automatically in less than 30 minutes with no further action required by you! ${helpText}`}
        />
        <ChannelInputWithButton
          {...{ inputText, isButtonDisabled, canShowTooltip, renderTooltip }}
          onAddChannel={handleAddChannel}
          onInputChange={handleInputChange}
        />
        <ChannelsListWrapper />
        <ClaimContent>
          <CopyrightClaimWrapper />
        </ClaimContent>
      </ContainerWrapper>
    </>
  );
};

export default YoutubeWhitelist;
